import React, { Component, Fragment } from "react";
import ReactHtmlParser from "react-html-parser";
import { connect } from "react-redux";
import * as actions from "../../actions";
import PropTypes from "prop-types";
import { Form, FormSpy } from "react-final-form";
import arrayMutators from "final-form-arrays";
import createDecorator from "final-form-focus";
import Loader from "react-loader-spinner";

const focusOnErrors = createDecorator();

class PageWizard extends Component {
    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
    };

    static Page = ({ children }) => children;

    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            values: props.initialValues || {},
            validForm: false,
        };
    }

    next = (values) =>
        this.setState((state) => ({
            page: Math.min(state.page + 1, this.props.children.length - 1),
            values,
        }));

    previous = () => {
        this.setState((state) => ({
            page: Math.max(state.page - 1, 0),
        }));
        // this.props.toTop.current.scrollIntoView({ behavior: "smooth" });
    };

    handleSubmit = (values) => {
        const { children, onSubmit } = this.props;
        const { page } = this.state;
        const isLastPage = page === React.Children.count(children) - 1;
        if (isLastPage) {
            return onSubmit(values);
        } else {
            let stepPage = page + 1;
            this.next(values);
        }
    };

    render() {
        const { children, noOfPages, submitted, drp } = this.props;
        const { page, values, validForm } = this.state;
        const activePage = React.Children.toArray(children)[page];
        const isLastPage = page === noOfPages;
        const thankYouMessage = drp
            ? "We're currently working on improvements to our email program. Keep an eye out for important information regarding NUPLAZID and Parkinson's disease&#8211;related hallucinations and delusions. We'll send the information you requested as soon as possible."
            : "We're currently working on improvements to our email program. Keep an eye out for important information regarding NUPLAZID and Parkinson's disease&#8211;related hallucinations and delusions. We'll send the information you requested as soon as possible.";
        return (
            <Form
                initialValues={values}
                onSubmit={this.handleSubmit}
                decorators={[focusOnErrors]}
                mutators={{
                    ...arrayMutators,
                }}
            >
                {({ form, handleSubmit, submitting, values }) => (
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-lg-12">
                                <div>
                                    {submitted && (
                                        <div
                                            className="offer-signup"
                                            style={{ marginTop: "10px" }}
                                        >
                                            <div className="col-md-12">
                                                <h3 class="font-white">
                                                    thank you for signing up.
                                                </h3>
                                                <p>
                                                    {ReactHtmlParser(
                                                        thankYouMessage
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                    )}
                                    {!submitted && (
                                        <Fragment>
                                            <h3 class="font-white">
                                                stay informed.
                                            </h3>
                                            {activePage}
                                        </Fragment>
                                    )}
                                    {isLastPage && !submitted && (
                                        <div className="row flex-row-reverse">
                                            <div className="col-lg-9">
                                                <p>
                                                    By clicking
                                                    &ldquo;Submit,&rdquo; I
                                                    understand and agree to the{" "}
                                                    <a
                                                        href="https://www.acadia-pharm.com/privacy/"
                                                        className="signup-terms-and-privacy"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Privacy Policy
                                                    </a>{" "}
                                                    and{" "}
                                                    <a
                                                        href="https://www.acadia-pharm.com/terms/"
                                                        className="signup-terms-and-privacy"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Terms of Use
                                                    </a>
                                                    . I&nbsp;agree to receive
                                                    communications from Acadia
                                                    Pharmaceuticals Inc.
                                                </p>
                                            </div>
                                            <div className="col-lg-3">
                                                <FormSpy
                                                    subscription={{
                                                        valid: true,
                                                    }}
                                                    onChange={(props) => {
                                                        this.setState({
                                                            ...this.state,
                                                            validForm:
                                                                props.valid,
                                                        });
                                                    }}
                                                />
                                                <button
                                                    id="pc-education-info-signup"
                                                    className={
                                                        "button white " +
                                                        (drp
                                                            ? " drp-button"
                                                            : " pdp-button") +
                                                        (submitting
                                                            ? "loading"
                                                            : " " +
                                                              (validForm
                                                                  ? " valid-submit"
                                                                  : " "))
                                                    }
                                                    type="submit"
                                                    disabled={submitting}
                                                >
                                                    <b>
                                                        Submit{" "}
                                                        <i
                                                            class="fa fa-angle-right ml-2 align-middle"
                                                            style={{
                                                                position:
                                                                    "relative",
                                                                top: "-3px",
                                                            }}
                                                        ></i>
                                                    </b>
                                                    {submitting && (
                                                        <Loader
                                                            type="ThreeDots"
                                                            color="#FFF"
                                                            height={100}
                                                            width={100}
                                                            className="loading-icon"
                                                        />
                                                    )}
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        {process.env.NODE_ENV === "development" && (
                            <pre
                                style={{
                                    marginTop: "100px",
                                    marginBottom: "50px",
                                }}
                            >
                                {JSON.stringify(values, 0, 2)}
                            </pre>
                        )}
                    </form>
                )}
            </Form>
        );
    }
}

const mapStateToProps = (state) => {
    const { currentStep } = state;
    return { currentStep: currentStep };
};

export default connect(mapStateToProps, actions)(PageWizard);
